import { render, staticRenderFns } from "./SquareMetersPriceTrendCard.vue?vue&type=template&id=403e4a54&"
import script from "./SquareMetersPriceTrendCard.vue?vue&type=script&lang=js&"
export * from "./SquareMetersPriceTrendCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports